import { ButtonHTMLAttributes } from 'react';
import { Icon } from './Icon';

interface CheckboxProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> {
  checked: boolean;
  onChange?: (next: boolean) => void;
}

export const Checkbox = ({ checked, onChange, onClick, ...rest }: CheckboxProps) => (
  <button
    type="button"
    className={`checkbox ${checked ? 'checked' : ''}`.trim()}
    aria-checked={checked}
    role="checkbox"
    onClick={(e) => {
      onChange?.(!checked);
      onClick?.(e);
    }}
    {...rest}
  >
    {checked && <Icon name="check" size={10} />}
  </button>
);

export default Checkbox;
